<template lang="pug">
.v-data-footer.d-flex.align-center.px-0(v-if="pagination.total")
  v-btn(
    @click="pagination.page = 1"
    :disabled="pagination.page <= 2"
    text
    fab
    tile
    small
  )
    v-icon mdi-chevron-double-left
  v-btn(@click="pagination.page -= 1" :disabled="pagination.page === 1" text fab tile small)
    v-icon mdi-chevron-left
  v-btn(@click="pagination.page += 1" :disabled="pagination.page >= pagesCount" text fab tile small)
    v-icon mdi-chevron-right
  v-btn(
    @click="pagination.page = pagination.pages"
    :disabled="pagination.page >= pagesCount - 1"
    text
    fab
    tile
    small
  )
    v-icon mdi-chevron-double-right

  p.caption.mb-0.mx-2.mr-auto
    | {{ (pagination.page - 1) * pagination.perPage + 1 }} - {{ maxItemsCount }}
    | из {{ pagination.total }}
  .d-flex.align-center.v-data-footer__select.ma-0
    p.caption.mb-0.mr-2 Количество строк:
    v-select.ma-0.rounded-0(
      filled
      v-model="pagination.perPage"
      :items="PER_PAGE_VALUES"
      hide-details
      dense
    )
</template>

<script>
import { PER_PAGE_VALUES } from '../constants';

export default {
  props:{
    pagination:{ type:Object, required: true },
  },
  data() {
    return { PER_PAGE_VALUES };
  },
  computed:{
    pagesCount() {
      return Math.ceil(this.pagination.total / this.pagination.perPage);
    },
    maxItemsCount() {
      return Math.min(this.pagination.page * this.pagination.perPage, this.pagination.total);
    },
  },

};
</script>

<style>

</style>
